import React, { useState, useRef } from "react"
import { graphql } from "gatsby"
import { makeStyles } from "@material-ui/core/styles"
import Layout from "../components/layout"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import MainToolbar from "../components/main-toolbar"
import SEO from "../components/seo"
import { injectIntl } from "gatsby-plugin-intl"
import LineTitle from "../components/LineTitle"
import SurgeonByline from "../components/SurgeonByline"
import Img from "gatsby-image"
import BackgroundImage from "gatsby-background-image"

const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: "#000",
    },
  },
  bannerGrid: {
    flexDirection: "row",
    ["@media (max-width:600px)"]: {
      paddingBottom: "0px",
      height: "42vh",
    },
  },
  bannerLeft: {
    display: "flex",
    justifyContent: "flex-start",
    paddingLeft: 20,
    [theme.breakpoints.down("md")]: {
      paddingLeft: 0,
    },
  },
  mainContainer: {
    padding: "0 !important",
    paddingBottom: "120px",
    backgroundColor: "#202020",
    [theme.breakpoints.down("md")]: {
      paddingBottom: "60px",
    },
  },
  tooLongtitle: {
    color: "white",
    maxWidth: 560,
    fontWeight: 400,
    ["@media (min-width:1440px)"]: {
      fontSize: "5rem",
    },
    ["@media (max-width:600px)"]: {
      fontSize: "2rem",
    },
  },
  tooLongSubheader: {
    color: "silver",
    textTransform: "uppercase",
    align: "left",
    marginTop: "20px",
    maxWidth: "650px",
    ["@media (max-width:600px)"]: {
      fontSize: "1.3rem",
    },
  },
  introHeader: {
    textAlign: "left",
    paddingTop: 0,
    paddingBottom: "1em",
    fontWeight: 300,
    maxWidth: 500,
    color: "white",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.4rem",
      paddingTop: 40,
    },
  },
  bodyText: {
    fontSize: "1.1rem",
    textAlign: "left",
    color: "white",
    maxWidth: 600,
    whiteSpace: "pre-line",
    paddingBottom: 20,
  },
  backgroundImg: {
    margin: 0,
    padding: 0,
    paddingBottom: theme.spacing(5),
    [theme.breakpoints.up("sm")]: {
      minHeight: "600px",
    },
    [theme.breakpoints.down("md")]: {
      backgroundPosition: "75% center",
      height: "280px",
    },
    ["@media (max-width:600px)"]: {
      backgroundPosition: "70% center",
      height: "380px",
    },
  },
  introContainer: {
    paddingTop: 120,
    paddingBottom: 40,
    paddingLeft: 40,
    paddingRight: 40,
    [theme.breakpoints.down("sm")]: {
      paddingTop: 40,
      paddingBottom: 0,
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  spacer: {
    height: 40,
  },
  reasonsSection: {
    background: "linear-gradient(180deg, #0F191F 0%, #0A1418 100%)",
    width: "100%",
    padding: "80px 5%",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "40px 28px",
    },
  },
  reasonsGrid: {
    alignItems: "center",
  },
  reasonsContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    padding: 0,
    margin: 0,
    maxWidth: "600px",
  },
  reasonsImageCol: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      marginTop: "30px",
    },
  },
  reasonsImage: {
    width: "100%",
    maxWidth: "500px",
    borderRadius: "4px",
  },
  reasonItem: {
    width: "100%",
    padding: "20px 0",
  },
  reasonHeader: {
    color: "white",
    fontWeight: 500,
    marginBottom: "10px",
    fontSize: "1.3rem",
  },
  reasonBodyText: {
    fontSize: "1.1rem",
    color: "white",
    whiteSpace: "pre-line",
    margin: 0,
  },
  clinicSection: {
    backgroundColor: "#202020",
    width: "100%",
    padding: "80px 5%",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "40px 20px",
    },
  },
  clinicContainer: {
    maxWidth: "900px",
    margin: 0,
  },
  clinicHeader: {
    color: "white",
    fontWeight: 300,
    marginBottom: "30px",
    textAlign: "left",
  },
  clinicText: {
    fontSize: "1.1rem",
    color: "white",
    whiteSpace: "pre-line",
    marginBottom: "30px",
    maxWidth: "720px",
  },
  scopeTitle: {
    color: "white",
    fontWeight: 500,
    marginBottom: "20px",
    fontSize: "1.3rem",
  },
  scopeList: {
    fontSize: "1.1rem",
    color: "white",
    paddingLeft: "20px",
    maxWidth: "720px",
    "& li": {
      marginBottom: "10px",
    },
  },
  caseStudySection: {
    background: "linear-gradient(180deg, #0F191F 0%, #0A1418 100%)",
    width: "100%",
    padding: "80px 5%",
    margin: 0,
    [theme.breakpoints.down("sm")]: {
      padding: "40px 20px",
    },
  },
  caseStudyContainer: {
    maxWidth: "1200px",
    margin: 0,
  },
  caseStudyGrid: {
    marginBottom: "80px",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "40px",
    },
  },
  caseStudyContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingRight: "40px",
    [theme.breakpoints.down("sm")]: {
      paddingRight: 0,
      marginBottom: "30px",
    },
  },
  caseStudyTitle: {
    color: "white",
    fontWeight: 300,
    marginBottom: "20px",
  },
  caseStudyText: {
    fontSize: "1.1rem",
    color: "white",
    whiteSpace: "pre-line",
    marginBottom: "20px",
    maxWidth: "720px",
  },
  testimonialBox: {
    backgroundColor: "rgba(255, 255, 255, 0.04)",
    border: "1px solid rgba(255, 255, 255, 0.06)",
    borderRadius: 8,
    padding: "28px 32px",
    marginTop: "10px",
    scrollMarginTop: "100px",
    [theme.breakpoints.down("sm")]: {
      padding: "20px 22px",
    },
  },
  testimonialLabel: {
    color: "silver",
    fontWeight: 500,
    fontSize: "1rem",
    marginBottom: "10px",
  },
  testimonialText: {
    fontSize: "1.1rem",
    color: "white",
    fontStyle: "italic",
    whiteSpace: "pre-line",
    maxWidth: "720px",
  },
  readMoreButton: {
    background: "none",
    border: "none",
    color: "#909090",
    cursor: "pointer",
    fontSize: "0.95rem",
    fontWeight: 700,
    padding: 0,
    marginTop: "2px",
    transition: "color 0.2s",
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      color: "white",
    },
    "@media (hover: hover)": {
      "&:hover": {
        color: "white",
      },
    },
  },
  caseStudyImageContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  caseStudyImage: {
    width: "100%",
    maxWidth: "500px",
  },
  imagePlaceholder: {
    width: "100%",
    maxWidth: "500px",
    height: "350px",
    backgroundColor: "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#666",
    fontSize: "1rem",
  },
  outroText: {
    fontSize: "1.1rem",
    color: "white",
    textAlign: "center",
    maxWidth: "800px",
    margin: "0 auto",
    padding: "40px 20px",
  },
}))

const FaceliftRevision = ({ intl, data, location }) => {
  const classes = useStyles()
  const t = (id) => intl.formatMessage({ id })
  const banner = data.bannerImage.childImageSharp.fluid
  const [case1Expanded, setCase1Expanded] = useState(false)
  const [case2Expanded, setCase2Expanded] = useState(false)
  const case1Ref = useRef(null)
  const case2Ref = useRef(null)

  const handleToggle = (expanded, setExpanded, ref) => () => {
    if (expanded && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" })
    }
    setExpanded((prev) => !prev)
  }

  return (
    <Layout>
      <SEO
        lang={intl.formatMessage({ id: "global.lang" })}
        title={intl.formatMessage({ id: "faceliftRevision.seoTitle" })}
        description={intl.formatMessage({ id: "faceliftRevision.seoDescription" })}
        path={location.pathname}
        medicalPage={{
          reviewer: "callum",
          lastReviewed: "2026-07-09",
          procedure: "Revision facelift",
        }}
      />
      <MainToolbar black />
      <Container maxWidth={"xl"} className={classes.mainContainer}>
        {/* Hero Section */}
        <section>
          <BackgroundImage
            fluid={banner}
            className={classes.backgroundImg}
            backgroundColor={`#333`}
          >
            <Grid container spacing={0} className={classes.bannerGrid}>
              <Grid item xs={12} sm={6} className={classes.bannerLeft}>
                <Container>
                  <LineTitle
                    header={t("faceliftRevision.title")}
                    subheader={t("faceliftRevision.subtitle")}
                    titleStyle={classes.tooLongtitle}
                    lightDecoLine
                    subHeaderStyle={classes.tooLongSubheader}
                  />
                </Container>
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
            </Grid>
          </BackgroundImage>
        </section>

        {/* Reasons Section */}
        <section className={classes.reasonsSection}>
          <Grid container spacing={6} className={classes.reasonsGrid}>
            <Grid item xs={12} md={6}>
              <div className={classes.reasonsContainer}>
                <div className={classes.reasonItem}>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.introText")}
                  </Typography>
                </div>
                <div className={classes.reasonItem}>
                  <Typography component="h3" className={classes.reasonHeader}>
                    {t("faceliftRevision.reasons.title1")}
                  </Typography>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.reasons.text1")}
                  </Typography>
                </div>
                <div className={classes.reasonItem}>
                  <Typography component="h3" className={classes.reasonHeader}>
                    {t("faceliftRevision.reasons.title2")}
                  </Typography>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.reasons.text2")}
                  </Typography>
                </div>
                <div className={classes.reasonItem}>
                  <Typography component="h3" className={classes.reasonHeader}>
                    {t("faceliftRevision.reasons.title3")}
                  </Typography>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.reasons.text3")}
                  </Typography>
                </div>
                <div className={classes.reasonItem}>
                  <Typography component="h3" className={classes.reasonHeader}>
                    {t("faceliftRevision.reasons.title4")}
                  </Typography>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.reasons.text4")}
                  </Typography>
                </div>
                <div className={classes.reasonItem}>
                  <Typography className={classes.reasonBodyText}>
                    {t("faceliftRevision.outro")}
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={6} className={classes.reasonsImageCol}>
              <Img
                fluid={data.patientCloseUp.childImageSharp.fluid}
                alt="Close-up of facial contour"
                className={classes.reasonsImage}
                imgStyle={{ borderRadius: "4px" }}
              />
            </Grid>
          </Grid>
        </section>

        {/* Cosmetic Complications Clinic Section */}
        <section className={classes.clinicSection}>
          <div className={classes.clinicContainer}>
            <Typography
              component="h2"
              variant="h3"
              className={classes.clinicHeader}
            >
              {t("faceliftRevision.clinicTitle")}
            </Typography>
            <p className={classes.clinicText}>
              {t("faceliftRevision.clinicText")}
            </p>
            <Typography component="h3" className={classes.scopeTitle}>
              {t("faceliftRevision.scopeTitle")}
            </Typography>
            <ul className={classes.scopeList}>
              <li>{t("faceliftRevision.scope.item1")}</li>
              <li>{t("faceliftRevision.scope.item2")}</li>
              <li>{t("faceliftRevision.scope.item3")}</li>
              <li>{t("faceliftRevision.scope.item4")}</li>
              <li>{t("faceliftRevision.scope.item5")}</li>
              <li>{t("faceliftRevision.scope.item6")}</li>
              <li>{t("faceliftRevision.scope.item7")}</li>
              <li>{t("faceliftRevision.scope.item8")}</li>
            </ul>
          </div>
        </section>

        {/* Case Studies Section */}
        <section className={classes.caseStudySection}>
          <div className={classes.caseStudyContainer}>
            {/* Case Study 1 */}
            <div className={classes.caseStudyGrid}>
              <Typography
                component="h3"
                variant="h4"
                className={classes.caseStudyTitle}
              >
                {t("faceliftRevision.caseStudy1.title")}
              </Typography>
              <p className={classes.caseStudyText}>
                {t("faceliftRevision.caseStudy1.description")}
              </p>
              <Grid container spacing={2} style={{ marginBottom: "30px" }}>
                <Grid item xs={12} md={4}>
                  <Img
                    fluid={data.revCase1Image1.childImageSharp.fluid}
                    alt="Revision case 1 - image 1"
                    style={{ borderRadius: "4px" }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Img
                    fluid={data.revCase1Image2.childImageSharp.fluid}
                    alt="Revision case 1 - image 2"
                    style={{ borderRadius: "4px" }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <Img
                    fluid={data.revCase1Image3.childImageSharp.fluid}
                    alt="Revision case 1 - image 3"
                    style={{ borderRadius: "4px" }}
                  />
                </Grid>
              </Grid>
              <div
                ref={case1Ref}
                className={case1Expanded ? classes.testimonialBox : ""}
              >
                <Typography className={classes.testimonialLabel}>
                  {t("faceliftRevision.testimonialLabel")}
                </Typography>
                <p className={classes.testimonialText}>
                  {case1Expanded
                    ? t("faceliftRevision.caseStudy1.testimonialFull")
                    : t("faceliftRevision.caseStudy1.testimonial")}
                </p>
                <button
                  type="button"
                  className={classes.readMoreButton}
                  onClick={handleToggle(case1Expanded, setCase1Expanded, case1Ref)}
                  aria-expanded={case1Expanded}
                >
                  {case1Expanded
                    ? t("faceliftRevision.readLessTestimonial")
                    : t("faceliftRevision.readMoreTestimonial")}
                </button>
              </div>
            </div>

            {/* Case Study 2 */}
            <div className={classes.caseStudyGrid}>
              <Typography
                component="h3"
                variant="h4"
                className={classes.caseStudyTitle}
              >
                {t("faceliftRevision.caseStudy2.title")}
              </Typography>
              <p className={classes.caseStudyText}>
                {t("faceliftRevision.caseStudy2.description")}
              </p>
              <Grid container spacing={2} style={{ marginBottom: "30px" }}>
                <Grid item xs={12} md={6}>
                  <Img
                    fluid={data.revCase2Image1.childImageSharp.fluid}
                    alt="Revision case 2 - image 1"
                    style={{ borderRadius: "4px" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Img
                    fluid={data.revCase2Image2.childImageSharp.fluid}
                    alt="Revision case 2 - image 2"
                    style={{ borderRadius: "4px" }}
                  />
                </Grid>
              </Grid>
              <div
                ref={case2Ref}
                className={case2Expanded ? classes.testimonialBox : ""}
              >
                <Typography className={classes.testimonialLabel}>
                  {t("faceliftRevision.testimonialLabel")}
                </Typography>
                <p className={classes.testimonialText}>
                  {case2Expanded
                    ? t("faceliftRevision.caseStudy2.testimonialFull")
                    : t("faceliftRevision.caseStudy2.testimonial")}
                </p>
                <button
                  type="button"
                  className={classes.readMoreButton}
                  onClick={handleToggle(case2Expanded, setCase2Expanded, case2Ref)}
                  aria-expanded={case2Expanded}
                >
                  {case2Expanded
                    ? t("faceliftRevision.readLessTestimonial")
                    : t("faceliftRevision.readMoreTestimonial")}
                </button>
              </div>
            </div>
          </div>
        </section>

        <section style={{ background: "#0A1418", padding: "24px 5% 80px" }}>
          <SurgeonByline surgeon="callum" />
        </section>
      </Container>
    </Layout>
  )
}

export default injectIntl(FaceliftRevision)

export const query = graphql`
  query {
    bannerImage: file(relativePath: { eq: "heros/revision-facelift-hero.webp" }) {
      childImageSharp {
        fluid(maxWidth: 2400, quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    }
    patientCloseUp: file(relativePath: { eq: "patient-close-up.webp" }) {
      childImageSharp {
        fluid(maxWidth: 800, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    revCase1Image1: file(relativePath: { eq: "before-after/revision/rev-web-1-1.webp" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    revCase1Image2: file(relativePath: { eq: "before-after/revision/rev-web-1-2.webp" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    revCase1Image3: file(relativePath: { eq: "before-after/revision/rev-web-1-3.webp" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    revCase2Image1: file(relativePath: { eq: "before-after/revision/rev-web-2-1.webp" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    revCase2Image2: file(relativePath: { eq: "before-after/revision/rev-web-2-2.webp" }) {
      childImageSharp {
        fluid(maxWidth: 600, quality: 90) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`
